import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getCookie, setCookie } from '@/lib/cookies';


// Import all translations
import commonEN from './locales/en/common.json';
import commonAR from './locales/ar/common.json';
import dashboardEN from './locales/en/dashboard.json';
import dashboardAR from './locales/ar/dashboard.json';
import productsEN from './locales/en/products.json';
import productsAR from './locales/ar/products.json';
import inventoryEN from './locales/en/inventory.json';
import inventoryAR from './locales/ar/inventory.json';
import analyticsEN from './locales/en/analytics.json';
import analyticsAR from './locales/ar/analytics.json';
import teamEN from './locales/en/team.json';
import teamAR from './locales/ar/team.json';
import settingsEN from './locales/en/settings.json';
import settingsAR from './locales/ar/settings.json';
import profileEN from './locales/en/profile.json';
import profileAR from './locales/ar/profile.json';
import performanceEN from './locales/en/performance.json';
import performanceAR from './locales/ar/performance.json';
import testingEN from './locales/en/testing.json';
import testingAR from './locales/ar/testing.json';
import notfoundEN from './locales/en/notfound.json';
import notfoundAR from './locales/ar/notfound.json';

const resources = {
  en: {
    common: commonEN,
    dashboard: dashboardEN,
    products: productsEN,
    inventory: inventoryEN,
    analytics: analyticsEN,
    team: teamEN,
    settings: settingsEN,
    profile: profileEN,
    performance: performanceEN,
    testing: testingEN,
    notfound: notfoundEN,
  },
  ar: {
    common: commonAR,
    dashboard: dashboardAR,
    products: productsAR,
    inventory: inventoryAR,
    analytics: analyticsAR,
    team: teamAR,
    settings: settingsAR,
    profile: profileAR,
    performance: performanceAR,
    testing: testingAR,
    notfound: notfoundAR,
  },
};

// Get language from cookie or localStorage or default to 'en'
const LANGUAGE_COOKIE = 'app_language';

// Safely get saved language with fallback
let savedLanguage = 'en';
try {
  savedLanguage = getCookie(LANGUAGE_COOKIE) || localStorage.getItem('language') || 'en';
} catch (error) {
  console.warn('Failed to get saved language, using default:', error);
  savedLanguage = 'en';
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'en',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
  });

// Save language preference to cookie when it changes
i18n.on('languageChanged', (lng) => {
  try {
    setCookie(LANGUAGE_COOKIE, lng, {
      expires: 365,
      path: '/',
      // Don't set domain - let browser handle it
      secure: window.location.protocol === 'https:',
      sameSite: 'lax',
    });
    
    localStorage.setItem('language', lng);
  } catch (error) {
    console.warn('Failed to save language preference:', error);
  }
  
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
});

// Set initial direction and language
try {
  document.documentElement.dir = savedLanguage === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.lang = savedLanguage;
} catch (error) {
  console.warn('Failed to set initial language:', error);
}

export default i18n;
